import React from 'react';

const CancelIcon = () => {
  return (
    <svg width="39" height="39" viewBox="0 0 39 39" fill="none">
      <rect
        x="0.652344"
        width="38.3467"
        height="38.3467"
        rx="19.1733"
        fill="#EBEBEB"
      />
      <path
        d="M24.4116 14.5867L15.2383 23.76M15.2383 14.5867L24.4116 23.76"
        stroke="#4E4E4E"
        strokeWidth="2.29333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CancelIcon;
